<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="clearfix flex justify-between">
            <span>查询条件</span>
          </div>
          <div class="">
            <el-form :inline="true" :model="queryStockManageInfo.conditions" class="flex justify-start">
              <el-form-item>
                <el-input v-model="queryStockManageInfo.conditions.prodName" placeholder="请输入商品名称" clearable />
              </el-form-item>
              <el-form-item>
                <el-input v-model="queryStockManageInfo.conditions.productId" placeholder="请输入商品编号" clearable />
              </el-form-item>
              <el-form-item>
                <el-select v-model="queryStockManageInfo.conditions.state" placeholder="请选择状态" style="width:100%"
                  clearable>
                  <el-option v-for="(item, index) in queryStockManageInfo.states" :key="index" :label="item.name"
                    :value="item.statusCd" />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="_queryShopHouseMethod">
                  <i class="el-icon-search"></i> 查询
                </el-button>
                <el-button @click="_resetShopHouseMethod">
                  <i class="el-icon-refresh"></i> 重置
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row class="margin-top-sm">
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="clearfix flex justify-between">
            <span>库存查询</span>
          </div>
          <div class="">
            <el-table :data="queryStockManageInfo.inoutOrders" border style="width: 100%">
              <el-table-column prop="shName" label="仓库" align="center" />
              <el-table-column prop="prodName" label="商品名称" align="center" />
              <el-table-column prop="barCode" label="商品条码" align="center" />
              <el-table-column prop="defaultSpecValue.specName" label="商品规格" align="center" />
              <el-table-column prop="unitName" label="商品单位" align="center" />
              <el-table-column prop="productId" label="商品编号" align="center" />
              <el-table-column prop="defaultSpecValue.stock" label="库存" align="center" />
              <el-table-column prop="inCount" label="进货次数" align="center" />
              <el-table-column prop="outCount" label="退货次数" align="center" />
              <el-table-column prop="inCount" label="将过期" align="center" />
              <el-table-column prop="outCount" label="耗损" align="center" />
              <el-table-column prop="stateName" label="状态" align="center" />
            </el-table>

            <el-pagination @current-change="handleCurrentChange" :current-page="queryStockManageInfo.conditions.page"
              :page-size="queryStockManageInfo.conditions.row" layout="total, prev, pager, next"
              :total="queryStockManageInfo.total" class="pagination" />
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'
import { getShopId } from '@/api/shop/shopApi'
import { listProductStock } from '@/api/goods/queryStockManageApi'

export default {
  name: 'QueryStockManage',
  data() {
    return {
      queryStockManageInfo: {
        inoutOrders: [],
        total: 0,
        records: 1,
        states: [],
        conditions: {
          prodName: '',
          productId: '',
          state: '',
          shopId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._initMethod()
    this.shopId = getShopId()
    this.queryStockManageInfo.conditions.shopId = this.shopId
    console.log(this.records)
  },
  methods: {
    async _initMethod() {
      await this._listInoutOrder(1, 10)
      try {
        const {data} = await getDict('product', 'state')
        this.queryStockManageInfo.states = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    async _listInoutOrder(page, rows) {
      this.queryStockManageInfo.conditions.page = page
      this.queryStockManageInfo.conditions.row = rows
      try {
        const res = await listProductStock(this.queryStockManageInfo.conditions)
        this.queryStockManageInfo.total = res.total
        this.queryStockManageInfo.records = res.records
        this.queryStockManageInfo.inoutOrders = res.data
      } catch (error) {
        console.error('请求失败处理:', error)
      }
    },
    _queryShopHouseMethod() {
      this._listInoutOrder(1, 10)
    },
    _resetShopHouseMethod() {
      this.queryStockManageInfo.conditions = {
        prodName: '',
        productId: '',
        state: '',
        shopId: this.shopId,
        page: 1,
        row: 10
      }
      this._listInoutOrder(1, 10)
    },
    handleCurrentChange(val) {
      this._listInoutOrder(val, this.queryStockManageInfo.conditions.row)
    }
  }
}
</script>

<style scoped>
.card-body {
  padding: 20px;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>